
module.exports = {
  title: 'Heading',
  context: {
    text: 'Heading 1<br />Line 2',
    tag: 'h1',
    class: 'heading-1',
    url: 'https://google.com'
  },
  variants: [
    {
      name: 'Heading 2',
      context: {
        text: 'Heading 2<br />Line 2',
        tag: 'h2',
        class: 'heading-2',
        url: 'https://google.com'
      },
    },
    {
      name: 'Heading 3',
      context: {
        text: 'Heading 3<br />Line 2',
        tag: 'h3',
        class: 'heading-3',
        url: 'https://google.com'
      },
    },
    {
      name: 'Heading 4',
      context: {
        text: 'Heading 4<br />Line 2',
        tag: 'h4',
        class: 'heading-4',
        url: 'https://google.com'
      },
    },
  ]
}